module.exports = new __parcel__URL__("shop_item_info_letter.a4ffd4e1.png").toString();